// Build SVG path strings for the sparkline, normalising the series into a fixed
// viewBox. preserveAspectRatio="none" stretches it to the container width while
// non-scaling stroke keeps the line weight constant.
export const buildSparkline = (data: number[]) => {
  const width = 100;
  const height = 36;
  const pad = 3;

  // A single data point is duplicated so the path renders as a flat horizontal
  // line rather than a degenerate dot; flat (min === max) series are centred
  // vertically instead of pinned to the bottom of the box.
  const points = data.length === 1 ? [data[0], data[0]] : data;
  const min = Math.min(...points);
  const max = Math.max(...points);
  const range = max - min;
  const stepX = (width - pad * 2) / (points.length - 1);

  const coords = points.map((value, index) => {
    const x = pad + index * stepX;
    const ratio = range === 0 ? 0.5 : (value - min) / range;
    const y = pad + (height - pad * 2) * (1 - ratio);
    return { x, y };
  });

  const line = coords
    .map(
      ({ x, y }, index) =>
        `${index === 0 ? "M" : "L"}${x.toFixed(2)} ${y.toFixed(2)}`,
    )
    .join(" ");

  const area = `${line} L${(width - pad).toFixed(2)} ${height} L${pad} ${height} Z`;

  return { line, area, viewBox: `0 0 ${width} ${height}` };
};
